/** LOADED: model active. REFUSED: model has errors, the previous one stays active. FAILED: no model active. */
export type ModelState = 'LOADED' | 'REFUSED' | 'FAILED';

export interface ModelIssue {
  severity: string;
  file: string;
  /** JSON pointer into the definition file. */
  path: string;
  message: string;
}

export interface ModelStatus {
  state: ModelState;
  checkedAt: string;
  errors: ModelIssue[];
  warnings: ModelIssue[];
  /** Number of definition files written in an older definition format. */
  upgradableFiles: number;
}

export interface ModelUpgradeDownload {
  blob: Blob;
  filename: string;
}

export function isModelProblem(status: ModelStatus): boolean {
  return status.state === 'REFUSED' || status.state === 'FAILED';
}
